export const TIPS = {
    NAME: {
        ROUTES: {
            HOME_VIEW: 'home_view',
            WELCOME_VIEW: 'welcome_view',

            USUARIOS_VIEW: 'usuarios_view',
            USUARIO_PERFILES_VIEW: 'usuario_perfiles_view',

            PERFILES_VIEW: 'perfiles_view',
            PERFIL_PERMISOS_VIEW: 'perfil_permisos_view',

            NOT_FOUND: 'not_found',
        },
        MODALS: {
            ARCHIVO_MODAL: 'archivo_modal',
            OBSERVACION_MODAL: 'observacion_modal',
            ETIQUETA_MODAL: 'etiqueta_modal',
            ENTIDADES_MODAL: 'entidades_modal',
            INFORMACION_ADICIONAL_USUARIO_MODAL: 'informacion_adicional_usuario_modal',
            PERFIL_MODAL: 'perfil_modal',
            PERMISO_MODAL: 'permiso_modal',
            USUARIO_MODAL: 'usuario_modal',
            OFICINA_MODAL: 'oficina_modal',
        }
    },
};
